import React from 'react';

const Features = () => {
  const features = [
    {
      title: "Real-time Question Management",
      description: "Manage live questions from your audience in real-time. Sort, filter, and prioritize questions effortlessly using our intuitive drag-and-drop interface.",
      image: "/features/question_manager.png"
    },
    {
      title: "Audience View",
      description: "Give your audience a clean, intuitive interface to submit and vote on questions. Encourage participation and engagement with real-time updates.",
      image: "/features/audience_questions.png"
    },
    {
      title: "Broadcast-Ready Display View",
      description: "Seamlessly integrate with professional broadcast software like OBS, vMix, or Tricaster. Perfect for adding real-time question overlays to your live stream or broadcast feed with transparent backgrounds and customizable styles.",
      image: "/features/display_view.png"
    },
    {
      title: "Live On-Air Management",
      description: "Control which questions go live instantly. Perfect for live broadcasts, streaming, and hybrid events where timing is crucial.",
      image: "/features/on_air.png"
    },
    {
      title: "Custom Template Editor",
      description: "Create and save custom display templates that match your brand. Customize colors, layouts, and styles to perfectly fit your broadcast design.",
      image: "/features/template_editor.png"
    }
  ];

  return (
    <div id="features" className="bg-white py-12 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            Powerful Features for Live Broadcasting
          </h2>
          <p className="mt-4 text-xl text-gray-500">
            Everything you need to manage live questions and integrate with professional broadcast software
          </p>
        </div>

        <div className="mt-16">
          <div className="space-y-20">
            {features.map((feature, index) => (
              <div 
                key={index} 
                className="grid lg:grid-cols-2 gap-8 items-center"
              >
                {index % 2 === 0 ? (
                  <>
                    <div className="relative">
                      <div className="aspect-w-16 aspect-h-9 rounded-lg shadow-lg overflow-hidden bg-gray-100">
                        <img 
                          src={feature.image}
                          alt={feature.title}
                          className="w-full h-full object-cover"
                        />
                      </div>
                    </div>
                    <div>
                      <h3 className="text-2xl font-extrabold text-gray-900">
                        {feature.title}
                      </h3>
                      <p className="mt-3 text-lg text-gray-500">
                        {feature.description}
                      </p>
                      {feature.title === "Broadcast-Ready Display View" && (
                        <div className="mt-4 inline-flex items-center space-x-4">
                          <span className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm font-medium">
                            OBS Studio
                          </span>
                          <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-medium">
                            vMix
                          </span>
                          <span className="px-3 py-1 bg-purple-100 text-purple-800 rounded-full text-sm font-medium">
                            Tricaster
                          </span>
                        </div>
                      )}
                    </div>
                  </>
                ) : (
                  <>
                    <div>
                      <h3 className="text-2xl font-extrabold text-gray-900">
                        {feature.title}
                      </h3>
                      <p className="mt-3 text-lg text-gray-500">
                        {feature.description}
                      </p>
                      {feature.title === "Broadcast-Ready Display View" && (
                        <div className="mt-4 inline-flex items-center space-x-4">
                          <span className="px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm font-medium">
                            OBS Studio
                          </span>
                          <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-medium">
                            vMix
                          </span>
                          <span className="px-3 py-1 bg-purple-100 text-purple-800 rounded-full text-sm font-medium">
                            Tricaster
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="relative">
                      <div className="aspect-w-16 aspect-h-9 rounded-lg shadow-lg overflow-hidden bg-gray-100">
                        <img 
                          src={feature.image}
                          alt={feature.title}
                          className="w-full h-full object-cover"
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features; 